import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Trans, translate } from 'react-i18next';
import { compose } from 'recompose';
import axios from 'axios';
// import PreBook from './PreBook.js';
// import * as $ from 'jquery';
// import moment from 'moment-timezone';
// import { Redirect } from 'react-router-dom';
import GoBackButton from '../../components/GoBackButton';
import Tag from '../../components/Tag';
import { clasificacion } from '../../helpers/centerClassification';

// import calendar from './../../images/calendar.png';
// import office from './../../images/office.png';
// import search from './../../images/search.png';

let cancelToken;
// let tokenSession;

const URI_VENTA_EN_LINEA = process.env.REACT_APP_URI_VENTA_EN_LINEA;
class Cowork extends Component {
    constructor(props) {
        super(props);
        // if (tokenSession !== props.getTokenSession()) {
        //     state = this.getInitState();
        // }
        this.state = {
            cowork: null,
            center: null,
        };
    }

    componentDidMount() {
        cancelToken = axios.CancelToken.source();
        if (this.props.match.params.id) {
            this.getCowork({
                token_id: this.props.getTokenId(),
                token_session: this.props.getTokenSession(),
                cowork_id: this.props.match.params.id
            })
        }
    }

    componentWillUnmount() {
        cancelToken.cancel('Component will unmount.');
        // tokenSession = this.props.getTokenSession();
    }

    getCowork = (params) => {
        this.props.post_store(
            "/getCowork",
            params,
            (response) => {
                this.setState({ cowork: response })
                this.getCenter({
                    token_id: this.props.getTokenId(),
                    center_id: response.centro_id
                });
            },
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    getCenter = (params) => {
        this.props.post_store(
            "/getCentersByCity",
            params,
            (response) => this.setState({ center: response }),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    handleClick = () => {
        const id = this.props.match.params.id;
        this.props.history.replace(`${URI_VENTA_EN_LINEA}/cowork/coworkedpayment/${id}`)
    }

    renderCoworedContainer = () => {
        const cowork = this.state.cowork;
        const center = this.state.center;
        console.log(cowork)

        if (!center) return null

        const mapUrl = new URL(`https://www.google.com/maps/search/?api=1&query=${center.name}`);
        const { t } = this.props;
        return (
            <div className="container-room">
                <div className="container-room-header card-panel panel panel-default card">
                    {/* <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + cowork.imagen + "')" }}>
                    </div> */}
                    <div className="card-panel-body">
                        <h2
                            className="ioscentro"
                            style={{ textAlign: 'left' }}
                        >{cowork.centro_name.toUpperCase()}</h2>

                        <section className="row match-height">
                            <article className="col-md-6">
                                <div className="flex-tags flex-tags__big">
                                    <Tag
                                        isBigTag
                                        icon='medal'
                                        text={t('venta_linea.index.cowork.category')}
                                        value={clasificacion(cowork.coworks_clasificacion)}
                                    />
                                    <Tag
                                        isBigTag
                                        alt
                                        icon='star'
                                        text={cowork.coworks_clasificacion === 'Plus' ? 'Multicentro' : 'Unicentro'}
                                        value={cowork.coworks_clasificacion === 'Plus' ? t('venta_linea.reservation_tags.beneficio_plus_description') : ''}
                                    />
                                </div>
                                <Tag
                                    isBigTag
                                    icon='dollar-sign'
                                    text={t('venta_linea.reservation_tags.price_month')}
                                    value={`${cowork.precio} ${cowork.moneda_id === 1 ? 'MXN' : 'USD'}`}
                                />
                                <div className="container-room-description">
                                    <h4 className="page-header text-primary">
                                        <strong>{t('dashboard.reservations.heading_services')}</strong>
                                    </h4>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <p>
                                                <strong>{t('dashboard.reservations.heading_included')}</strong>
                                            </p>
                                            <section className="flex-tags">
                                                {cowork.servicios_incluidos.map((service) =>
                                                    <Tag
                                                        key={service.id}
                                                        id={service.id}
                                                        text={service.name}
                                                    />
                                                )}
                                            </section>
                                        </div>
                                        <div className="col-md-12">
                                            <p>
                                                <strong>{t('dashboard.reservations.heading_extras')}</strong>
                                            </p>
                                            <section className="flex-tags">
                                                {cowork.servicios_adicionales.map((service) =>
                                                    <Tag
                                                        key={service.id}
                                                        id={service.id}
                                                        text={service.name}
                                                    />
                                                )}
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </article>

                            <section className="col-md-6">
                                <div className="panel-heading card-panel-heading" style={{
                                    backgroundImage: "url('" + cowork.imagen + "')",
                                    height: '400px',
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center'
                                }}>
                                </div>
                                <div className="panel-body-description">
                                    <div className="">
                                        {cowork.coworks_descripcion.slice(0, 150)}{cowork.coworks_descripcion.length > 150 ? '...' : null}
                                    </div>
                                </div>
                            </section>
                        </section>

                        <div className="row match-height">
                            <div className="col-md-6 only-desktop">
                                <div className="container-direction mapa">
                                    <div className="iframe-wrapper no-margin">
                                        <iframe
                                            frameBorder="0"
                                            src={
                                                "https://www.google.com/maps/d/embed?mid=1Cd02Lz4Q-XK73pQs9iA5jMJk86k&ll="
                                                + center.longitude
                                                + "%2C"
                                                + center.latitud
                                            }
                                            title={t('dashboard.reservations.frame_center')}>
                                        </iframe>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 flex-address">
                                <h3>
                                    <Trans>guest.vcontract.contract_details.label_adress</Trans>
                                </h3>
                                <a href={mapUrl.toString()} target='_blank'>
                                    <p>
                                        {center.direccion}
                                        <br></br>
                                        {center.ciudad}
                                        <br></br>
                                        {center.estado}
                                        <br></br>
                                        {center.cp}
                                    </p>
                                </a>
                            </div>
                        </div>

                        <div className="panel-body-bottom">
                            <div className="panel-body form-group">
                                <button
                                    className="btn btn-block btn-primary  btn-singup btn_create"
                                    onClick={this.handleClick}
                                    type="button">
                                    <Trans>dashboard.reservations.btn_pay</Trans>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    handleErrorResponse = (error) => {
        alert(error)
    }

    render() {
        const { t } = this.props;
        return (
            <div className="content-resvations">
                <div className="container-resvations-title">
                    <GoBackButton />
                    <h2 className="page-header">{t("dashboard.reservations.heading")}</h2>
                </div>
                {this.state.cowork ? (
                    this.renderCoworedContainer()
                ) : null}
            </div>

        )
    }

}

export default compose(
    translate('common'),
    withRouter
)(Cowork);


// WEBPACK FOOTER //
// ./src/store/Cowork/Cowork.js